import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.footerText}>
            <p>
              Гостиничные чеки в Челябинске от «CHEKi74». Официальная страница для заказа командировочных документов © 2020-2024
            </p>
          </div>
        </div>
      </div>
      
      {/* Scroll to top button */}
      <button className={styles.scrollToTop} onClick={scrollToTop}>
        <i className="fa fa-angle-up"></i>
      </button>
    </footer>
  );
};

export default Footer;